import Vue from 'vue'
import VueRouter from 'vue-router'
import Empty from '@/views/layout/empty'
import Index from '@/views/layout/index'
import SaleIndex from '@/views/layout/saleIndex'
import CenterMain from '@/views/layout/centerMain'
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/index',
  },
    {
        path: '/index',
        component: Index,
        children:[
            {
                path: '',
                name: '首页',
                component: () => import('../views/Home.vue')
            }
        ]
    },
    {
        path: '/search',
        name: '买兰花',
        component: Index,
        children:[
            {
                path: '/search/:oneTypeId?/:oneTypeName?/:twoTypeId?/:twoTypeName?/:goodsName?',
                name: '商品搜索',
                component: () => import('../views/goods/search.vue')
            }
        ]
    },
    {
        path: '/business',
        name: '卖家工作台',
        component: SaleIndex,
        children:[
            {
                path: '',
                name: '店铺营收',
                component: () => import('../views/business/revenue.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'apply',
                name: '商家申请',
                component: () => import('../views/business/apply.vue'),
                meta:{requireAuth: true}
            },

            {
                path: 'order',
                name: '订单数据',
                component: () => import('../views/business/order.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'goodsManage',
                name: '商品管理',
                component: () => import('../views/business/goodsManage.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'releaseGoods/:goodsId?',
                name: '发布竞拍商品',
                component: () => import('../views/business/releaseGoods.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'releaseVideoGoods/:goodsId?',
                name: '发布视频商品',
                component: () => import('../views/business/releaseVideoGoods.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'releaseGeneralGoods/:goodsId?',
                name: '发布普通商品',
                component: () => import('../views/business/releaseGeneralGoods.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'edit',
                name: '店铺管理',
                component: () => import('../views/business/shopManage.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'celebrityApply',
                name:'成为名人',
                component: () => import('../views/celebrity/apply.vue'),
                meta:{requireAuth: true}
            }
        ]
    },
    {
        path: '/session/:userId?',
        component: Index,
        children:[
            {
                path: '',
                name: '会话',
                component: () => import( '../views/session.vue'),
                meta:{requireAuth: true}
            }
        ]
    },
    {
        path: '/goods',
        component: Empty,
        children:[
            {
                path: '',
                name: '商品',
                component: Index,
                children:[
                    {
                        path: '',
                        name: '',
                        component: () => import('../views/goods/index.vue')
                    },
                    {
                        path: 'detail/:id',
                        name: '商品详情',
                        component: () => import('../views/goods/detail.vue')
                    },
                    {
                        path: 'order/detail/:goodsId/:goodsNum',
                        name: '确认订单',
                        component: () => import('../views/goods/order/detail.vue'),
                        meta:{requireAuth: true}
                    },
                    {
                        path: 'order/pay/:orderId',
                        name: '立即支付',
                        component: () => import('../views/goods/order/pay.vue'),
                        meta:{requireAuth: true}
                    }
                ]

            },
            {
                path: 'order/applyAfterSale/:orderId',
                name: '申请售后',
                component: () => import('../views/goods/order/applyAfterSale.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'order/pinJia/:orderId',
                name: '评价订单',
                component: () => import('../views/goods/order/pinJia.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'order/payOk',
                name: '支付订单成功',
                component: () => import('../views/goods/order/payOk.vue'),
                meta:{requireAuth: true}
            }
        ]

    },
    {
        path: '/article',
        name: '兰花文章',
        component: Index,
        children:[
            {
                path: '',
                name: '文章列表',
                component: () => import('../views/article/index.vue')
            },
            {
                path: 'add',
                name: '写文章',
                component: () => import('../views/article/add.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'detail/:id',
                name: '文章详情',
                component: () => import('../views/article/detail.vue')
            }
        ]
    },
    {
        path: '/shop',
        name: '兰花店铺',
        component: Index,
        children:[
            {
                path: '',
                component: () => import('../views/shop/index.vue')
            },
            {
                path: 'detail/:id',
                name: '店铺详情',
                component: () => import('../views/shop/detail.vue')
            }
        ]
    },
    {
        path: '/friends',
        component: Index,
        children:[
            {
                path: '',
                name: '兰友圈',
                component: () => import('../views/friends/index.vue')
            }
        ]
    },
    {
        path: '/celebrity',
        component: Index,
        name: '名人介绍',
        children:[
            {
                path: '',
                component: () => import('../views/celebrity/index.vue')
            },
            {
                path: 'detail/:id',
                component: Empty,
                name:'名人个人资料',
                children:[
                    {
                        path: '',
                        component: () => import('../views/celebrity/detail.vue'),
                    },
                    {
                        path: '/celebrity/track/:id',
                        name: '最新动态',
                        component: () => import('../views/celebrity/track.vue')
                    },
                    {
                        path: 'article/detail/:id',
                        name: '文章详情',
                        component: () => import('../views/celebrity/article/detail.vue')
                    }
                ]
            },
            // {
            //     path: 'detail/:id',
            //     name: '名人个人资料',
            //     component:Empty,
            //     children:[
            //         {
            //             path: '',
            //             component: () => import('../views/celebrity/detail.vue'),
            //         },
            //         {
            //             path: 'article/detail/:id',
            //             name: '文章详情',
            //             component: () => import('../views/celebrity/article/detail.vue')
            //         }
            //     ]
            // },
        ]
    },
    {
        path: '/orchid',
        component: Index,
        name: '名兰介绍',
        children:[
            {
                path: '',
                component: () => import('../views/orchid/index.vue')
            }

        ]
    },
    {
        path: '/center',
        component: CenterMain,
        name: '我的',
        children:[
            {
                path: 'index',
                component: () => import('../views/center/index.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'wallet',
                name:'钱包',
                component: () => import('../views/center/wallet.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'address',
                name:'收货地址',
                component: () => import('../views/center/address.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'order',
                name:'我的订单',
                component: () => import('../views/center/order.vue'),
                meta:{requireAuth: true}
            },
            {
                path: 'followed',
                name:'我的关注',
                component: () => import('../views/center/followed.vue'),
                meta:{requireAuth: true}
            }
        ]
    },
    {
        path: '/myCenter',
        component: Empty,
        name: '首页',
        children:[
            {
                path: 'order',
                component: Index,
                name: '我的订单',
                children:[
                    {
                        path: 'detail/:id/:role?',
                        name:`订单详情`,
                        component: () => import('../views/center/orderDetail.vue'),
                        meta:{requireAuth: true}
                    }
                ]
            }

        ]
    }
]

const router = new VueRouter({
  //mode: 'history',
  //base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
})

export default router
